'use strict';

var util = angular.module('gymsystem.util');

util.directive('todolist', ['$rootScope', '$modal', function($rootScope, $modal) {
    return {
        restrict: 'E',
        template: '<customertable config="config" />',
        scope: {
            settings: '='
        },
        link: function($scope) {
            var all_columns = [
                {field: 'todo', title: 'ToDo'},
                {field: 'dueDate', title: 'Due date', format: 'date'},
                {field: 'responsible.name', title: 'Responsible' },
            ];

            var columns = $scope.settings.columns.map(function(column_id) {
                return _.findWhere(all_columns, {field: column_id});
            });

            $scope.config = {
                api: {
                    url: '/api/todo/get',
                    args: {
                        staff: $rootScope.currentStaffId,
                        fromDate: Date.today().yyyymmdd(),
                        toDate: Date.today().yyyymmdd(),
                        delayed: true
                    },
                    transform: $rootScope.transformTodo,
                    triggers: [{type: 'todo'}]
                },
                hideSearch: true,
                showHeader: false,
                itemFilter: function(todo) { return !todo.performed; },
                rowClick: function(todo) {
                    $modal.open({
                        templateUrl: 'views/todomodal.html',
                        controller: 'ToDoModalCtrl',
                        resolve: {
                            todo: function() {
                                return todo;
                            }
                        }
                    });
                },
                columns: columns
            };
        }
    };
}]);
